<template>
  <!-- Public marketing pages (no sidebar, with site header/footer) -->
  <div v-if="isPublicPage" id="app" class="min-h-screen flex flex-col" style="background: var(--surface-bg); color: var(--ink);">
    <SiteHeader />
    <main class="flex-1">
      <RouterView />
    </main>
    <SiteFooter />
  </div>

  <!-- Authenticated admin pages (with sidebar) -->
  <div v-else id="app" class="h-screen bg-background flex overflow-hidden">
    <!-- Sidebar Navigation -->
    <AppSidebar ref="sidebar" />

    <!-- Main Content Area -->
    <div class="flex-1 flex flex-col lg:ml-64 transition-all duration-300 overflow-hidden">
      <!-- Top Header (Mobile Menu Toggle) -->
      <AppHeader @toggle-mobile-menu="toggleMobileMenu" />

      <!-- Main Content -->
      <main class="flex-1 overflow-y-auto">
        <RouterView />
      </main>

      <!-- Footer -->
      <AppFooter />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { RouterView, useRoute } from 'vue-router'
import AppSidebar from '@/components/layout/AppSidebar.vue'
import AppHeader from '@/components/layout/AppHeader.vue'
import AppFooter from '@/components/layout/AppFooter.vue'
import SiteHeader from '@/components/marketing/SiteHeader.vue'
import SiteFooter from '@/components/marketing/SiteFooter.vue'

const route = useRoute()
const sidebar = ref<InstanceType<typeof AppSidebar> | null>(null)

const PUBLIC_ROUTES = new Set(['home', 'contact', 'field-notes'])

const isPublicPage = computed(() => {
  return typeof route.name === 'string' && PUBLIC_ROUTES.has(route.name)
})

const toggleMobileMenu = () => {
  sidebar.value?.toggleMobileMenu()
}
</script>
